export const getNotificationValueText = (
  fieldLabel: string,
  value: string | null | undefined,
) => {
  const normalizedFieldLabel = fieldLabel.trim().toLowerCase();

  if (typeof value === "string" && value.trim().length > 0) {
    return value;
  }

  if (
    normalizedFieldLabel === "issue status" ||
    normalizedFieldLabel === "discrepancy status"
  ) {
    return "Empty";
  }

  if (normalizedFieldLabel === "assignee") {
    return "Unassigned";
  }

  return "Unknown value";
};
